export default import.meta.ROLLDOWN_FILE_URL_lSex8WDd7oI0k1CxMrZ2IA